import {Component, OnInit, Input, ApplicationRef, OnDestroy} from '@angular/core';
import {Project} from '../../data/project/project';
import {ProjectHolder} from '../../interfaces/project-holder';
import {ProjectService} from '../../data/project/project.service';
import {KanbanColumn} from 'projects/desktop/src/app/modules/kanban-board/data/kanban-column';
import {KanbanBoardService} from 'projects/desktop/src/app/modules/kanban-board/data/kanban-board.service';
import {KanbanBoardStore} from 'projects/desktop/src/app/modules/kanban-board/data/kanban-board.store';
import {MatSnackBarRef, SimpleSnackBar, MatSnackBar} from '@angular/material/snack-bar';
import {WsUpdateResponce} from '../../../data/ws-update-responce';
import {filter} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {WsService} from '../../../data/ws.service';
import {TrelloCard} from '../../../trello-misc/data/trello-card';

@Component({
  selector: 'app-project-status-edit',
  templateUrl: './project-status-edit.component.html',
  styleUrls: ['./project-status-edit.component.scss']
})
export class ProjectStatusEditComponent implements OnInit, OnDestroy {
  project: Project;

  @Input()
  cardId: number;

  @Input()
  columnId: number;

  status: KanbanColumn;
  tempStatus: KanbanColumn;

  oldListId: number;

  statuses: KanbanColumn[];

  activeSnackBar: MatSnackBarRef<SimpleSnackBar>

  wsSub: Subscription;

  constructor(
    private snackBar: MatSnackBar,
    protected appRef: ApplicationRef,
    protected kanbanBoardService: KanbanBoardService,
    protected kanbanBoardStore: KanbanBoardStore,
    protected projectHolder: ProjectHolder,
    private projectService: ProjectService,
    protected wsService: WsService
  ) {
    this.project = this.projectHolder.project
  }

  ngOnInit() {
    this.initRealTimeUpdate();

    this.kanbanBoardService.getColumnNames().subscribe(statuses => {
      this.statuses = statuses
      this.status = statuses.find(fstatus => fstatus.id === this.columnId)
      if (this.status) {
        this.oldListId = this.status.id
        this.tempStatus = this.status;
      }
    })
  }

  initRealTimeUpdate() {
    this.wsSub = this.wsService
      .listenUntilDestroyed<WsUpdateResponce<TrelloCard>>('/topic/update/model.trello.TrelloCard', this)
      .pipe(
        filter(updateInfo => updateInfo.entity.id === this.project.card.id),
      )
      .subscribe(updateInfo => {
        this.status = this.statuses.find(fstatus => fstatus.id === updateInfo.entity?.list?.id)
      })

  }

  moveCard(newStatus: KanbanColumn) {
    const oldListId = this.oldListId;
    this.status = newStatus
    this.oldListId = this.status.id

    this.kanbanBoardService.moveCard(this.cardId, newStatus.id, -1).subscribe(card => {
        this.kanbanBoardService.projectRemove.emit({
          columnId: oldListId,
          projectId: this.project.id
        });

        this.kanbanBoardService.projectInsert.emit({
          columnId: newStatus.id,
          project: this.project,
          index: card.pos
        });

        this.kanbanBoardStore.updateActiveColumnId(newStatus.id)
        this.tempStatus = this.status;
      },
      error => {
        if (error.message === 'Drawing not approved') {
          this.openSnackBar(error.message)
        } else if (error.status === 500 || error.status === 0) {
          this.openSnackBar('Server Error')
        } else {
          this.openSnackBar(error.message)
        }
        this.status = this.tempStatus
      })
  }

  openSnackBar(message: string, duration = null) {
    if (this.activeSnackBar) {
      this.activeSnackBar.dismiss();
    }
    duration = (duration !== null
        ? duration
        : Math.min(2000 + message.length * 50, 15000)) as number;
    // console.log(message, 'duration', duration)

    this.activeSnackBar = this.snackBar.open(message, '', {
      duration,
      panelClass: 'drag-error-snackbar',
      verticalPosition: 'top',
    });
  }

  ngOnDestroy() {
    if (this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }
  }

  // statusChange(status: KanbanColumn) {
  // 	this.status = status
  // 	this.projectService
  // 		.saveProject({
  // 			id: this.project.id,
  // 			card: {
  // 				id: this.status.id
  // 			}
  // 		})
  // 		.subscribe(() => {
  // 		})
  // }

}
